import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { App } from './App';
import { CustomerLogin } from './pages/auth/CustomerLogin';
import { CustomerRegister } from './pages/auth/CustomerRegister';
import { VendorLogin } from './pages/auth/VendorLogin';
import { VendorRegister } from './pages/auth/VendorRegister';
import { AuthProvider } from './components/auth/AuthContext';
import { VendorPortal } from './pages/vendor/VendorPortal';
import { Dashboard } from './pages/vendor/Dashboard';
import { Services } from './pages/vendor/Services';
import { Orders } from './pages/vendor/Orders';
import { Profile } from './pages/vendor/Profile';
import { CustomerPortal } from './pages/customer/CustomerPortal';
import { Dashboard as CustomerDashboard } from './pages/customer/Dashboard';
import { Orders as CustomerOrders } from './pages/customer/Orders';
import { RequestService } from './pages/customer/RequestService';
import { PaymentPage } from './pages/customer/PaymentPage';
import { Profile as CustomerProfile } from './pages/customer/Profile';
import { PublicRequestService } from './pages/public/RequestService';
import { BecomeVendor } from './pages/BecomeVendor';
export function AppRouter() {
  return <BrowserRouter data-id="element-9">
      <AuthProvider data-id="element-10">
        <Routes data-id="element-11">
          <Route path="/" element={<App data-id="element-13" />} data-id="element-12" />
          <Route path="/become-vendor" element={<BecomeVendor data-id="element-15" />} data-id="element-14" />
          <Route path="/request-service" element={<PublicRequestService data-id="element-17" />} data-id="element-16" />
          <Route path="/auth/customer-login" element={<CustomerLogin data-id="element-19" />} data-id="element-18" />
          <Route path="/auth/customer-register" element={<CustomerRegister data-id="element-21" />} data-id="element-20" />
          <Route path="/auth/vendor-login" element={<VendorLogin data-id="element-23" />} data-id="element-22" />
          <Route path="/auth/vendor-register" element={<VendorRegister data-id="element-25" />} data-id="element-24" />
          {/* Vendor Portal Routes */}
          <Route path="/vendor" element={<VendorPortal data-id="element-27" />} data-id="element-26">
            <Route index element={<Dashboard data-id="element-29" />} data-id="element-28" />
            <Route path="dashboard" element={<Dashboard data-id="element-31" />} data-id="element-30" />
            <Route path="services" element={<Services data-id="element-33" />} data-id="element-32" />
            <Route path="orders" element={<Orders data-id="element-35" />} data-id="element-34" />
            <Route path="profile" element={<Profile data-id="element-37" />} data-id="element-36" />
            <Route path="settings" element={<Profile data-id="element-39" />} data-id="element-38" />
          </Route>
          {/* Customer Portal Routes */}
          <Route path="/customer" element={<CustomerPortal data-id="element-41" />} data-id="element-40">
            <Route index element={<CustomerDashboard data-id="element-43" />} data-id="element-42" />
            <Route path="dashboard" element={<CustomerDashboard data-id="element-45" />} data-id="element-44" />
            <Route path="orders" element={<CustomerOrders data-id="element-47" />} data-id="element-46" />
            <Route path="request-service" element={<RequestService data-id="element-49" />} data-id="element-48" />
            <Route path="payment" element={<PaymentPage data-id="element-51" />} data-id="element-50" />
            <Route path="profile" element={<CustomerProfile data-id="element-53" />} data-id="element-52" />
            <Route path="settings" element={<CustomerProfile data-id="element-55" />} data-id="element-54" />
          </Route>
        </Routes>
      </AuthProvider>
    </BrowserRouter>;
}